import { render, staticRenderFns } from "./FrequentQuestionsMainView.vue?vue&type=template&id=bae8e6a4"
import script from "./FrequentQuestionsMainView.vue?vue&type=script&lang=js"
export * from "./FrequentQuestionsMainView.vue?vue&type=script&lang=js"
import style0 from "./FrequentQuestionsMainView.vue?vue&type=style&index=0&id=bae8e6a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports